import React from 'react';
import styled from 'styled-components';
import { Popconfirm as AntdPopconfirm } from 'antd';
import { PopconfirmProps as AntdPopconfirmProps } from 'antd/lib/popconfirm';
import { buildCssLengthProp } from 'utils';
import { NativeButtonProps } from 'antd/lib/button/button';
import { Text } from '../Typography';

export type PopconfirmProps = AntdPopconfirmProps & {
  width?: number | string;
  maxWidth?: number | string;
};

export const Popconfirm: React.FC<PopconfirmProps> = ({
  className,
  title,
  width,
  maxWidth,
  onVisibleChange,
  ...props
}) => {
  // This is needed to fix a bug when you use the component with a controlled visibility
  // Without this the component doesn't close on blur
  const getOnVisibleChange = () => {
    const { open, onCancel } = props;
    if (onVisibleChange) return onVisibleChange;
    if (onCancel && typeof open === 'boolean') {
      return (
        newVisibility: boolean,
        e: React.MouseEvent<HTMLElement, MouseEvent>,
      ) => {
        if (!newVisibility) onCancel(e);
      };
    }
    return undefined;
  };

  return (
    <StyledPopconfirm
      okButtonProps={{ 'data-cy': 'popconfirm-ok-button' } as NativeButtonProps}
      cancelButtonProps={
        { 'data-cy': 'popconfirm-cancel-button' } as NativeButtonProps
      }
      {...props}
      onOpenChange={getOnVisibleChange()}
      $width={width}
      $maxWidth={maxWidth}
      title={
        typeof title === 'string' ? (
          <Text type="secondary">{title}</Text>
        ) : (
          title
        )
      }
    />
  );
};

// This logic allows it to be used as a styled-component
const PreparedPopconfirm = ({ className, ...props }: AntdPopconfirmProps) => (
  <AntdPopconfirm overlayClassName={className} {...props} />
);

const StyledPopconfirm = styled(PreparedPopconfirm)<{
  $width?: number | string;
  $maxWidth?: number | string;
}>`
  ${({ $width, $maxWidth }) =>
    `
    ${buildCssLengthProp('width', $width)}
    ${buildCssLengthProp('max-width', $maxWidth)}
  `};
`;

export default Popconfirm;
